'use client'

import { useEffect, useState } from 'react'

export default function AutoSurveyPopup({
  surveyUrl = 'https://surveidigital.spbe.go.id/embed/survey/eyJzdXJ2ZXlfaWQiOjIsInNlcnZpY2VfaWQiOjM0OSwiaG9zdCI6Imh0dHBzOi8vdWx0LmtlbWVuZGlrZGFzbWVuLmdvLmlkLyxodHRwczovL3VsdC5hdW0uc3RhZ2luZy5iZWxhamFyLmlkLyxodHRwOi8vbG9jYWxob3N0OjMwMDAvLGh0dHBzOi8vcHVzYXRpbmZvcm1hc2kudWx0LmtlbWVuZGlrZGFzbWVuLmdvLmlkLyIsImtleSI6ImVvbzVXMzVaIn0=/embed/view/?jenis_layanan=Website ULT - Layanan Informasi Kanal Pengaduan ULT',
}) {
  const [isModalOpen, setIsModalOpen] = useState(false)

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsModalOpen(true)
    }, 15000)

    return () => clearTimeout(timer)
  }, [])

  if (!isModalOpen) return null

  return (
    <div
      className="fixed inset-0 z-[1000] flex items-center justify-center"
      onClick={() => setIsModalOpen(false)}
    >
      <div
        className="relative flex flex-col w-[90%] max-w-4xl h-[80%] max-h-[700px] bg-white p-5 text-center rounded-lg shadow-2xl border"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          className="absolute right-5 top-4 text-gray-400 hover:text-black text-3xl font-bold leading-none transition-colors duration-200"
          onClick={() => setIsModalOpen(false)}
          aria-label="Tutup"
        >
          &times;
        </button>

        <h3 className="mb-5 mt-2.5 text-xl font-bold text-gray-800">
          Survei Layanan
        </h3>

        <iframe
          id="resultIframe"
          src={surveyUrl}
          className="w-full h-[85%] min-h-[400px] border-none rounded-lg"
          title="Survei Penilaian"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    </div>
  )
}
